var ENVIRONMENT = ((process.env.VUE_APP_API_MODE != undefined) ? process.env.VUE_APP_API_MODE: 'development') == 'development' ;
var CHECK_PERMISSION = true;
import store from '../store'
// import moment from 'moment'
import moment from 'moment-timezone'; 
export const constants = {
    getUrlChecker: () => {
        const baseURL = ENVIRONMENT? constants.getDomainCurrent() : (process.env.VUE_APP_URL_CHEKER == undefined ? constants.getDomainCurrent() : process.env.VUE_APP_URL_CHEKER);
        return baseURL;
    },
    getDomainCurrent: () => {
        var domain = window.location.protocol + '//' + window.location.host;
        return domain;
    },
    converMillimeterToPixel: (milimeter = 1) => {
        return milimeter * 3.77953
    },
    converInchToPixel: (inch = 1) => {
        return inch * 96
    },
    getFileName: (file) => {
        if (file.length) {
          var arrSplit = file.split('/')
          return arrSplit[arrSplit.length - 1];
        }
    },
    getFileExtension: (fileName) => {
        return fileName.split('.').pop()
    },
    twoDigits: (value) => {
        if (value < 0) return '00';
        if (value.toString().length <= 1) return `0${value}`;
        return value;
    },
    replaceAt: (str, index, chr) => {
        if(index > str.length-1) return str;
        return str.substring(0,index) + chr + str.substring(index+1);
    },
    replaceAllSpace: (text, char = '') => {
        const newText = text.split(/\s/).join(char);
        return newText;
    },
    cleanAccents: (str, slug = ' ') => {
        str = str.toLowerCase()
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
        str = str.replace(/đ/g, 'd')
        str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A')
        str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E')
        str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I')
        str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O')
        str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U')
        str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y')
        str = str.replace(/Đ/g, 'D')
        // Combining Diacritical Marks
        str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, slug)
        str = str.replace(/\u02C6|\u0306|\u031B/g, slug)
        return str
    },
    ChangeToSlug: (title) => {
        //Đổi chữ hoa thành chữ thường
        var slug = title.toLowerCase();
        //Đổi ký tự có dấu thành không dấu
        slug = slug.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a');
        slug = slug.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e');
        slug = slug.replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i');
        slug = slug.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o');
        slug = slug.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u');
        slug = slug.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y');
        slug = slug.replace(/đ/gi, 'd');
        //Xóa các ký tự đặt biệt
        slug = slug.replace(/`|~|!|@|#|||\$|%|^|&|\*|\(|\)|\+|=|,|\.|\/|\?|>|<|'|"|:|;|_/gi, '');
        //Đổi khoảng trắng thành ký tự gạch ngang
        slug = slug.replace(/ /gi, "-");
        //Đổi nhiều ký tự gạch ngang liên tiếp thành 1 ký tự gạch ngang
        //Phòng trường hợp người nhập vào quá nhiều ký tự trắng
        slug = slug.replace(/-----/gi, '-');
        slug = slug.replace(/----/gi, '-');
        slug = slug.replace(/---/gi, '-');
        slug = slug.replace(/--/gi, '-');
        //Xóa các ký tự gạch ngang ở đầu và cuối
        slug = '@' + slug + '@';
        slug = slug.replace(/@-|-@|@/gi, '');
        return slug;
    },
    convertNumberToMinutesSecond: (number) => {
        var minutes = constants.twoDigits(Math.floor(number / 60));
        var seconds = constants.twoDigits(Math.floor(number % 60));
        return minutes + ':' + seconds;
    },
    convertMinutesSecondToNumber: (text) => {
        var arrText = text.split(':');
        return parseInt(arrText[0])*60 + parseInt(arrText[1]);
    },
    autoGenerateZero: (number, length = 4) => {
        var strNumber = number.toString();
        var len = length - strNumber.length;
        return new Array(len).fill(0).join('') + number;
    },
    autoGenerateZeroMinLength: (number, minLength = 4) => {
        var code = '';
        minLength = number.toString().length > minLength ? number.toString().length : minLength;
        code = constants.autoGenerateZero(number, minLength);
        return code;
    },
    checkInputTime: (text) => {
        if (text != '') {
            var arrText = text.split(':');
            if (parseInt(arrText[0]) > 59 || parseInt(arrText[1]) > 59) return true;
        }
        else if (text == '' || text == undefined || text == null) return true;
        return false;
    },
    shortenLargeNumber: (n) => {
        if (n < 1e3) return n;
        if (n >= 1e3) return +(n / 1e3).toFixed(1) + "K";
    },
    formatThousand: (val) => {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    isImage: (type) =>{
        return /^image\//.test(type);
    },
    isJSON: (str) => {
        try {
            return (JSON.parse(str) && !!str)
        } catch (e) {
            return false;
        }
    },
    isValidDate: (d) => {
        return d instanceof Date && !isNaN(d);
    },
    isValid: (string) => {
        var re = /^[ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s\W|!@#/$%/^/&*/)/(+=._-`]+$/g
        return re.test(string);
    },
    createId: (availableChars, idLength) => {
        let id = '';
        for (let i = 0; i < idLength; i += 1) {
          id += availableChars[constants.getRandomNumber(availableChars.length)];
        }
        return id;
    },
    getRandomNumber: (limit)  => {
        return Math.floor(Math.random() * limit).toString();
    },
    filterSymbols: (excludeSymbols, group) => {
        let newGroup = group;
        excludeSymbols.forEach((symbol) => {
          newGroup = newGroup.replace(symbol, '');
        });
        return newGroup;
    },
    generateUniqueId: (length = 20, useLetters = true, useNumbers = true, excludeSymbols = []) => {
        let letters = 'abcdefghijklmnopqrstuvwxyz';
        let numbers = '0123456789';
        let availableChars = [];
        let lettersArr = [];
        let numbersArr = [];
        if (useLetters) {
          if (excludeSymbols.length) letters = constants.filterSymbols(excludeSymbols, letters);
          lettersArr = letters.split('');
        }
        if (useNumbers) {
          if (excludeSymbols.length) numbers = constants.filterSymbols(excludeSymbols, numbers);
          numbersArr = numbers.split('');
        }
        availableChars = [...lettersArr, ...numbersArr];
        return constants.createId(availableChars, length);
    },
    convertLocalDateToUTCDate: (date, toUTC) => {
        date = new Date(date);
        var localOffset = date.getTimezoneOffset() * 60000;
        var localTime = date.getTime();
        if (toUTC) {
            date = localTime + localOffset;
        } else {
            date = localTime - localOffset;
        }
        date = new Date(date);
        return date;
    },
    convertDateSymbol: (date, symbolForm = '/', symbolTo = '-') => {
        return date.split(symbolForm).reverse().join(symbolTo)
    },
    timeZone: () => {
        // var d = new Date();
        // var usertime = d.toLocaleString();
        // // Some browsers / OSs provide the timezone name in their local string:
        // var tzsregex = /\b(ACDT|ACST|ACT|ADT|AEDT|AEST|AFT|AKDT|AKST|AMST|AMT|ART|AST|AWDT|AWST|AZOST|AZT|BDT|BIOT|BIT|BOT|BRT|BST|BTT|CAT|CCT|CDT|CEDT|CEST|CET|CHADT|CHAST|CIST|CKT|CLST|CLT|COST|COT|CST|CT|CVT|CXT|CHST|DFT|EAST|EAT|ECT|EDT|EEDT|EEST|EET|EST|FJT|FKST|FKT|GALT|GET|GFT|GILT|GIT|GMT|GST|GYT|HADT|HAEC|HAST|HKT|HMT|HST|ICT|IDT|IRKT|IRST|IST|JST|KRAT|KST|LHST|LINT|MART|MAGT|MDT|MET|MEST|MIT|MSD|MSK|MST|MUT|MYT|NDT|NFT|NPT|NST|NT|NZDT|NZST|OMST|PDT|PETT|PHOT|PKT|PST|RET|SAMT|SAST|SBT|SCT|SGT|SLT|SST|TAHT|THA|UYST|UYT|VET|VLAT|WAT|WEDT|WEST|WET|WST|YAKT|YEKT)\b/gi;

        // // In other browsers the timezone needs to be estimated based on the offset:
        // var timezonenames = {"UTC+0":"GMT","UTC+1":"CET","UTC+2":"EET","UTC+3":"EEDT","UTC+3.5":"IRST","UTC+4":"MSD","UTC+4.5":"AFT","UTC+5":"PKT","UTC+5.5":"IST","UTC+6":"BST","UTC+6.5":"MST","UTC+7":"THA","UTC+8":"AWST","UTC+9":"AWDT","UTC+9.5":"ACST","UTC+10":"AEST","UTC+10.5":"ACDT","UTC+11":"AEDT","UTC+11.5":"NFT","UTC+12":"NZST","UTC-1":"AZOST","UTC-2":"GST","UTC-3":"BRT","UTC-3.5":"NST","UTC-4":"CLT","UTC-4.5":"VET","UTC-5":"EST","UTC-6":"CST","UTC-7":"MST","UTC-8":"PST","UTC-9":"AKST","UTC-9.5":"MIT","UTC-10":"HST","UTC-11":"SST","UTC-12":"BIT"};

        // var timezone = usertime.match(tzsregex);
        // if (timezone) {
        //     timezone = timezone[timezone.length-1];
        // } else {
        //     var offset = -1*d.getTimezoneOffset()/60;
        //     offset = "UTC" + (offset >= 0 ? "+" + offset : offset);
        //     timezone = timezonenames[offset];
        // }
        var timezone = 'Asia/Bangkok';
        return timezone;
    },
    currentDate: (currentDate = '') => {
        var dateUTC = new Date().toUTCString();
        if (currentDate != '') {
            var d = new Date(currentDate);
            dateUTC = d.toUTCString();
        }
        var  date = moment.tz(dateUTC, constants.timeZone()).format('YYYY-MM-DD HH:mm:ss')
        return date;
    },
    checkDisplayMenu: (permission, groupName) => {
        if (!CHECK_PERMISSION || (store.getters.fullname != undefined && store.getters.fullname != null && 
            store.getters.fullname.user_type != undefined && store.getters.fullname.user_type == 3)) return true;
        else  {
            if (permission != null) {
                permission = permission.filter(a => a != undefined);
               // console.log("a.taba.tab:",permission);
                var returnData = permission.filter(a => a.group == groupName || a.tab == groupName);
               // console.log('groupNamegroupName:',groupName)
                //console.log('returnDatareturnData:',returnData)
                if (groupName == "report"){
                    for (var j=0;j<permission.length;j++){
                        if (
                            permission[j].group == 'report_warranty_activation'
                            || permission[j].group == 'report_appraisal_product'
                            || permission[j].group == 'report_repair_warranty_maintenance'
                            || permission[j].group == 'report_service_supplies'
                        ){
                            return true;
                        }
                    }
                    //return true;
                }
                var exists = returnData && Object.keys(returnData).length > 0;
                if (!exists) {
                    var childData = permission.filter(a => a.group + '_' + a.action == groupName);
                    return childData && Object.keys(childData).length > 0;
                } else return true;
            }
        }
    },
    checkRoleGroup(groupName, action) {
        return this.checkVisible(store.getters.permission, groupName, action);
    },
    checkVisible: (permission, groupName, action) => {
        if (!permission){
            //nếu ko tồn tại permission thì lấy permission local
            const getPermission = localStorage.getItem('Permission');
            permission = (getPermission) ? JSON.parse(getPermission):null;
        }
        if (!CHECK_PERMISSION || (store.getters.fullname != undefined && store.getters.fullname != null && 
            store.getters.fullname.user_type != undefined && store.getters.fullname.user_type == 3)) return true;
        else  {
            if (permission != null) {
                permission = permission.filter(a => a != undefined);
                var returnData = permission.filter(a => a.group == groupName && a.action == action);
                if (action == 'all') returnData = permission.filter(a => a.group == groupName);
                return returnData && Object.keys(returnData).length > 0;
            }
        }
    },
    checkPermisson: () => {
        return CHECK_PERMISSION;
    },
    organizationCountUser: () => {
        if (store.getters.fullname.organization_account != undefined && store.getters.fullname.organization_account != null) {
            return  (store.getters.fullname.organization_account.organization != undefined && store.getters.fullname.organization_account.organization != null) ? store.getters.fullname.organization_account.organization.number_of_accounts : 0;
        }
        return 0;
    },
    organizationUserLogin: () => {
        if (store.getters.fullname.organization_account != undefined && store.getters.fullname.organization_account != null) {
            return  (store.getters.fullname.organization_account.organization != undefined && store.getters.fullname.organization_account.organization != null) ? store.getters.fullname.organization_account.organization : null;
        }
        return 0;
    },
    managementLevel: () => {
        if (store.getters.role != undefined && store.getters.role != null &&
            store.getters.role.roles != undefined && store.getters.role.roles != null) {
            return  (store.getters.role.roles.is_management_lower_level != undefined && store.getters.role.roles.is_management_lower_level != null) ? store.getters.role.roles.is_management_lower_level : false;
        }
        return false
    },
    levelParent: () => {
        if( store.getters.fullname.user_level != undefined && store.getters.fullname.user_level != null) {
            return (store.getters.fullname.user_level.parent_id != undefined && store.getters.fullname.user_level.parent_id != null) ? store.getters.fullname.user_level.parent_id : 0;
        }
        return 0;
    },
    mailValidation: (email) => {
        email = email.trim();
        var expr = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;///^([\w-\\.]+)@((\[[0-9]{1,3}\\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        return expr.test(email);
    },
    switchUnit:  (key) => {
        var value = ''
        switch (key) {
             case "day":
                value = "ngày";
                break;
            case "month":
                value = "tháng";
                break;
        }
        return value;
    },
    convertToDate: (date, time, unit) => {
        var expiredDate = moment(date).add(time, unit);
        var productDate = moment.tz(expiredDate, constants.timeZone());
        return productDate;
    },
    calcDayByMonth: (date, time, unit) => {
        var expiredDate = moment(date).add(time, unit);
        var productDate = moment.tz(expiredDate, constants.timeZone());
        var from_date_m = moment(date);
        var to_date_m = moment(productDate);
        var diffDays = to_date_m.diff(from_date_m, 'days');
        try {
            //diffDays += 1;
            return diffDays;
        } catch (err) {
            return diffDays;
        }
    },
    isLeap: (year) => {
        return new Date(year, 1, 29).getDate() === 29;
    }, 
    daysCurrentOfMonth: (date) => {
        var now = new Date();
        if (date != null && date != '') now = new Date(date);
        return now.getDate();
    },
    daysOfMonth: (year, month) => {
        var date = new Date(year, month, 0);
        return date.getDate();
    },
    convertDaysMonthYear: (year, month, days) => {
        var text = '';
        var text1 = '';
        //số ngày của tháng
        var daysMonthCurrent = constants.daysOfMonth(year, month);
        if (days <= daysMonthCurrent) {
            text = '<abbr class="timeline">(Còn ' + days + ' ngày)</abbr>';
            text1 = ' '+ days + ' ngày';
        } else  {
            var k = 0;
            while(k >= 0) {
                var daysMonth = constants.daysOfMonth(year, month);
                var daysTmp = days - daysMonth;
                if (daysTmp < 0) break;
                if (daysTmp >= 0) {
                    days -= daysMonth;
                    k++;
                    month++;
                    if(month > 12) {
                        month = 1;
                        year++;
                    }
                }
            }
            // if (k > 12) {
            //     text = '<abbr class="timeline">(Còn ' +  (k/12) + ' năm ' + (k % 12) + ' tháng';
            //     text1 = (k/12) + ' năm ' + (k % 12) + ' tháng';
            // } else {
                text = '<abbr class="timeline">(Còn ' +  k + ' tháng';
                text1 = k + ' tháng';
            // }
            if (days > 0) {
                text += ' '+ days + ' ngày';
                text1 += ' '+ days + ' ngày';
            }
            text += ')</abbr>';
        }
        return [text, text1];
    },
        returnDateCustomText: (dataDateArr) => {
            var warranty_time = dataDateArr.warranty_time;
            var returnable_time = dataDateArr.returnable_time;
            var change_time = dataDateArr.change_time;
            var warranty_status = dataDateArr.warranty_status;
            var activation_date = dataDateArr.activation_date;
            var arrWarrantyStatus = (dataDateArr.arrWarrantyStatus) ? dataDateArr.arrWarrantyStatus:null;
            var warranty_unit = (dataDateArr.warranty_unit) ? dataDateArr.warranty_unit:'month';

            var warranty_time_text = "";
            var warranty_time_text1 = "";
            if (warranty_unit == 'day'){
                warranty_time_text = warranty_time + ' ngày';
                warranty_time_text1 = warranty_time + ' ngày';
            }else {
                warranty_time_text = warranty_time + ' tháng';
                warranty_time_text1 = warranty_time + ' tháng';
            }
            var returnable_time_text = returnable_time + ' ngày';
            var returnable_time_text1 = returnable_time + ' ngày';
            var change_time_text = change_time + ' ngày';
            var change_time_text1 = change_time + ' ngày';
            var now = new Date();
            var endReturn = now.getTime();
            if (warranty_status == 3 || warranty_status == 4 || (arrWarrantyStatus != null && arrWarrantyStatus.includes(warranty_status))) {
                if (activation_date != '' && (warranty_status == 3 || (arrWarrantyStatus != null && arrWarrantyStatus.includes(warranty_status)))) {
                    //tính toán ra số ngày
                    var diffDays = 0;
                    if (warranty_unit == 'day'){
                        diffDays = warranty_time;
                    }else {
                        var expiredDate = constants.convertToDate(activation_date, warranty_time, 'M');
                        var date1 = new Date((now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear());
                        var date2 = new Date(expiredDate.format('MM') + "/" + expiredDate.format('DD') + "/" + expiredDate.format('YYYY'));

                        var diffTime = Math.abs(date2 - date1);
                        diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                    }

                    //ngày hiện tại
                    var fromDate = constants.convertToDate(activation_date, 0, 'M');
                    var month  = fromDate.format('MM');
                    var year = fromDate.format('YYYY')
                    //xử lý ra năm, tháng và ngày
                    var arrs = constants.convertDaysMonthYear(year, month, diffDays);
                    console.log("arrsarrsarrsarrs:",arrs)
                    warranty_time_text += arrs[0];
                    warranty_time_text1 = arrs[1];
                }

                var one_day = (1000 * 60 * 60 * 24);
                var startReturn =  constants.convertToDate(activation_date, 0,  'days');

                startReturn = new Date(startReturn.format('YYYY'), startReturn.format('MM') - 1, startReturn.format('DD')).getTime();
                var daysStartReturn = Math.floor(startReturn) / (one_day);
                var daysEndReturn = Math.floor(endReturn) / (one_day);
                var changeTime = (change_time != undefined && change_time != null) ? change_time : 0;

                var returnableTime = (returnable_time != undefined && returnable_time != null) ? returnable_time : 0;

                if ((daysEndReturn - daysStartReturn) > changeTime) {
                    change_time_text += '<abbr class="timeline">(Hết thời hạn đổi)</abbr>';
                    change_time_text1 = 'Còn 0 ngày';
                }
                else  {
                    var calcChange =  constants.convertToDate(activation_date, changeTime + 1,  'days');
                    calcChange = new Date(calcChange.format('YYYY'), calcChange.format('MM') - 1, calcChange.format('DD')).getTime();
                    var daysChange = Math.floor((calcChange - endReturn) / one_day);
                    if (daysChange > 0) {
                        change_time_text += '<abbr class="timeline">(Còn ' +  daysChange + ' ngày)</abbr>';
                        change_time_text1 = 'Còn ' + daysChange + ' ngày';
                    } else {
                        change_time_text += '<abbr class="timeline">(Hết thời hạn đổi)</abbr>';
                        change_time_text1 = 'Còn 0 ngày';
                    }
                }

                if ((daysEndReturn - daysStartReturn) > returnableTime) {
                    returnable_time_text += '<abbr class="timeline">(Hết thời hạn trả)</abbr>';
                    returnable_time_text1 = 'Còn 0 ngày';
                } else  {
                    var calcReturn =  constants.convertToDate(activation_date, returnableTime + 1,  'days');
                    calcReturn = new Date(calcReturn.format('YYYY'), calcReturn.format('MM') - 1, calcReturn.format('DD')).getTime();
                    var daysReturn = Math.floor((calcReturn - endReturn) / one_day);
                    if (daysReturn > 0) {
                        returnable_time_text += '<abbr class="timeline">(Còn ' +  daysReturn + ' ngày)</abbr>';
                        returnable_time_text1 = 'Còn ' + daysReturn + ' ngày';
                    } else {
                        returnable_time_text += '<abbr class="timeline">(Hết thời hạn trả)</abbr>';
                        returnable_time_text1 = 'Còn 0 ngày';
                    }
                }
            }
            return {
                warranty_time_text:warranty_time_text,
                returnable_time_text:returnable_time_text,
                change_time_text:change_time_text,
                warranty_time_text1:warranty_time_text1,
                returnable_time_text1:returnable_time_text1,
                change_time_text1:change_time_text1,
            };
            //return [warranty_time_text, returnable_time_text, change_time_text, warranty_time_text1, returnable_time_text1, change_time_text1];
        },
    returnTimeCustomText: (dataDateArr) => {
        var returnable_time = dataDateArr.returnable_time;
        var change_time = dataDateArr.change_time;
        var warranty_status = dataDateArr.warranty_status;
        var activation_date = dataDateArr.activation_date;
        var arrWarrantyStatus = (dataDateArr.arrWarrantyStatus) ? dataDateArr.arrWarrantyStatus:null;

        var returnable_time_text = returnable_time + ' ngày';
        var returnable_time_text1 = returnable_time + ' ngày';
        var change_time_text = change_time + ' ngày';
        var change_time_text1 = change_time + ' ngày';
        var now = new Date();
        var endReturn = now.getTime();
        if (warranty_status == 3 || warranty_status == 4 || (arrWarrantyStatus != null && arrWarrantyStatus.includes(warranty_status))) {

            var one_day = (1000 * 60 * 60 * 24);
            var startReturn =  constants.convertToDate(activation_date, 0,  'days');

            startReturn = new Date(startReturn.format('YYYY'), startReturn.format('MM') - 1, startReturn.format('DD')).getTime();
            var daysStartReturn = Math.floor(startReturn) / (one_day);
            var daysEndReturn = Math.floor(endReturn) / (one_day);
            var changeTime = (change_time != undefined && change_time != null) ? change_time : 0;

            var returnableTime = (returnable_time != undefined && returnable_time != null) ? returnable_time : 0;

            if ((daysEndReturn - daysStartReturn) > changeTime) {
                change_time_text += '<abbr class="timeline">(Hết thời hạn đổi)</abbr>';
                change_time_text1 = 'Còn 0 ngày';
            }
            else  {
                var calcChange =  constants.convertToDate(activation_date, changeTime + 1,  'days');
                calcChange = new Date(calcChange.format('YYYY'), calcChange.format('MM') - 1, calcChange.format('DD')).getTime();
                var daysChange = Math.floor((calcChange - endReturn) / one_day);
                if (daysChange > 0) {
                    change_time_text += '<abbr class="timeline">(Còn ' +  daysChange + ' ngày)</abbr>';
                    change_time_text1 = 'Còn ' + daysChange + ' ngày';
                } else {
                    change_time_text += '<abbr class="timeline">(Hết thời hạn đổi)</abbr>';
                    change_time_text1 = 'Còn 0 ngày';
                }
            }

            if ((daysEndReturn - daysStartReturn) > returnableTime) {
                returnable_time_text += '<abbr class="timeline">(Hết thời hạn trả)</abbr>';
                returnable_time_text1 = 'Còn 0 ngày';
            } else  {
                var calcReturn =  constants.convertToDate(activation_date, returnableTime + 1,  'days');
                calcReturn = new Date(calcReturn.format('YYYY'), calcReturn.format('MM') - 1, calcReturn.format('DD')).getTime();
                var daysReturn = Math.floor((calcReturn - endReturn) / one_day);
                if (daysReturn > 0) {
                    returnable_time_text += '<abbr class="timeline">(Còn ' +  daysReturn + ' ngày)</abbr>';
                    returnable_time_text1 = 'Còn ' + daysReturn + ' ngày';
                } else {
                    returnable_time_text += '<abbr class="timeline">(Hết thời hạn trả)</abbr>';
                    returnable_time_text1 = 'Còn 0 ngày';
                }
            }
        }
        return {
            //warranty_time_text:warranty_time_text,
            returnable_time_text:returnable_time_text,
            change_time_text:change_time_text,
            //warranty_time_text1:warranty_time_text1,
            returnable_time_text1:returnable_time_text1,
            change_time_text1:change_time_text1,
        };
        //return [warranty_time_text, returnable_time_text, change_time_text, warranty_time_text1, returnable_time_text1, change_time_text1];
    },
    /*returnDateCustomText: (warranty_time, returnable_time, change_time, warranty_status, activation_date, arrWarrantyStatus = null) => {
        var warranty_time_text = warranty_time + ' tháng';
        var warranty_time_text1 = warranty_time + ' tháng';
        var returnable_time_text = returnable_time + ' ngày';
        var returnable_time_text1 = returnable_time + ' ngày';
        var change_time_text = change_time + ' ngày';
        var change_time_text1 = change_time + ' ngày';
        var now = new Date();
        var endReturn = now.getTime();
        if (warranty_status == 3 || warranty_status == 4 || (arrWarrantyStatus != null && arrWarrantyStatus.includes(warranty_status))) {
            if (activation_date != '' && (warranty_status == 3 || (arrWarrantyStatus != null && arrWarrantyStatus.includes(warranty_status)))) {
               //tính toán ra số ngày
                var expiredDate = constants.convertToDate(activation_date, warranty_time, 'M');
                var date1 = new Date((now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear());
                var date2 = new Date(expiredDate.format('MM') + "/" + expiredDate.format('DD') + "/" + expiredDate.format('YYYY'));
               
                var diffTime = Math.abs(date2 - date1);
                var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 

                //ngày hiện tại
                var fromDate = constants.convertToDate(activation_date, 0, 'M');
                var month  = fromDate.format('MM');
                var year = fromDate.format('YYYY')
                //xử lý ra năm, tháng và ngày
                var arrs = constants.convertDaysMonthYear(year, month, diffDays);
                warranty_time_text += arrs[0];
                warranty_time_text1 = arrs[1];
            }

            var one_day = (1000 * 60 * 60 * 24);
            var startReturn =  constants.convertToDate(activation_date, 0,  'days');
            
            startReturn = new Date(startReturn.format('YYYY'), startReturn.format('MM') - 1, startReturn.format('DD')).getTime();
            var daysStartReturn = Math.floor(startReturn) / (one_day);
            var daysEndReturn = Math.floor(endReturn) / (one_day);
            var changeTime = (change_time != undefined && change_time != null) ? change_time : 0;

            var returnableTime = (returnable_time != undefined && returnable_time != null) ? returnable_time : 0;

            if ((daysEndReturn - daysStartReturn) > changeTime) {
                change_time_text += '<abbr class="timeline">(Hết thời hạn đổi)</abbr>';
                change_time_text1 = 'Còn 0 ngày';
            }
            else  {
                var calcChange =  constants.convertToDate(activation_date, changeTime + 1,  'days');
                calcChange = new Date(calcChange.format('YYYY'), calcChange.format('MM') - 1, calcChange.format('DD')).getTime();
                var daysChange = Math.floor((calcChange - endReturn) / one_day);
                if (daysChange > 0) {
                    change_time_text += '<abbr class="timeline">(Còn ' +  daysChange + ' ngày)</abbr>';
                    change_time_text1 = 'Còn ' + daysChange + ' ngày';
                } else {
                    change_time_text += '<abbr class="timeline">(Hết thời hạn đổi)</abbr>';
                    change_time_text1 = 'Còn 0 ngày';
                }
            }

            if ((daysEndReturn - daysStartReturn) > returnableTime) {
                returnable_time_text += '<abbr class="timeline">(Hết thời hạn trả)</abbr>';
                returnable_time_text1 = 'Còn 0 ngày';
            } else  {
                var calcReturn =  constants.convertToDate(activation_date, returnableTime + 1,  'days');
                calcReturn = new Date(calcReturn.format('YYYY'), calcReturn.format('MM') - 1, calcReturn.format('DD')).getTime();
                var daysReturn = Math.floor((calcReturn - endReturn) / one_day);
                if (daysReturn > 0) {
                    returnable_time_text += '<abbr class="timeline">(Còn ' +  daysReturn + ' ngày)</abbr>';
                    returnable_time_text1 = 'Còn ' + daysReturn + ' ngày';
                } else {
                    returnable_time_text += '<abbr class="timeline">(Hết thời hạn trả)</abbr>';
                    returnable_time_text1 = 'Còn 0 ngày';
                }
            }
        }

        return [warranty_time_text, returnable_time_text, change_time_text, warranty_time_text1, returnable_time_text1, change_time_text1];
    },*/
    isEmpty(a_var) {
        if (a_var === undefined || a_var === null || a_var === '')
            return true;
        return false;
    },
    SkipVN(str) {
        if (!str){
            return str;
        }
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        str = str.replace(/đ/g, "d");
        str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "a");
        str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "e");
        str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
        str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "o");
        str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "u");
        str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "y");
        str = str.replace(/Đ/g, "d");
        str = str.toLowerCase()
        return str;
    },
    convertJsonObject(obj) {
        if (this.isEmpty(obj)) {
            return null;
        }
        return JSON.parse(JSON.stringify(obj));
    },
    numberFormat(number, decimals, dec_point, thousands_sep) {
        var n = number, c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals;
        var d = dec_point == undefined ? "," : dec_point;
        var t = thousands_sep == undefined ? "." : thousands_sep, s = n < 0 ? "-" : "";
        var i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = (j = i.length) > 3 ? j % 3 : 0;

        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    },
    capitalizeFirst(str_data=''){
        //Chuyền in hoa ký tự đầu VD :Tran Minh An
        var str = str_data.toLowerCase();//chuyển hết về chữ thường
        const arr = str.split(" ");
        //loop through each element of the array and capitalize the first letter.
        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        }
        //Join all the elements of the array back into a string
        //using a blankspace as a separator
        return arr.join(" ");
    },
    validatePhone(phone='',phone_length=0){
        phone = phone.toString();
        if (phone.length != phone_length){
            return false;
        }
        //check ký tự đầu tiên có phải số 0 không
        if (phone.charAt(0) != '0'){
            return false;
        }
        var pattern = /^\d+$/;//check chỉ là số
        if (!pattern.test(phone)) {
            return false;
        }
        return true;//hợp lệ
    },
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },
    noop () {
        //Chặn redirect submit form
        return false;
    },
    convertDate(date_convert) {
        var dateNow = new Date();
        const [d, M, y] = date_convert.match(/\d+/g);
        var changeDate = new Date(y, M-1, d, dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds());
        var date_convert_return = changeDate.toUTCString();
        return date_convert_return;
    },
    convertWarrantyStatus(warranty_status) {
        var text_data = "";
        if (warranty_status == 2) text_data = 'Chờ kích hoạt';
        else if (warranty_status == 0 || warranty_status == 5) text_data = 'Chưa kích hoạt';
        else if (warranty_status == 4) text_data = 'Hết bảo hành';
        else if (warranty_status == 6) text_data = 'Sản phẩm huỷ';
        else if (warranty_status == 3 || warranty_status == 1) text_data = 'Đã kích hoạt';
        return text_data;
    },
    convertAddressCustomer(obj_customer_profile) {
        var str_text = "";
            if (obj_customer_profile){
                var item_customer_profile = obj_customer_profile;
                var name_province = (!constants.isEmpty(item_customer_profile.province)) ? item_customer_profile.province.name:'';
                var name_district = (!constants.isEmpty(item_customer_profile.district)) ? item_customer_profile.district.name:'';
                var name_ward = (!constants.isEmpty(item_customer_profile.ward)) ? item_customer_profile.ward.name:'';
                var delivery_apartment_number = (!constants.isEmpty(item_customer_profile.address)) ? item_customer_profile.address.trim():'';

                if (
                    !constants.isEmpty(name_province)
                    && !constants.isEmpty(name_district)
                    && !constants.isEmpty(name_ward)
                    && !constants.isEmpty(delivery_apartment_number)
                ){
                    str_text = delivery_apartment_number+', '+name_ward+', '+name_district+', '+name_province;
                }
            }
        return str_text;
    },
    replaceAll(str, find, replace) {
        var find_char = find.replace(/[-[]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
        return str.replace(new RegExp(find_char, 'g'), replace);
    },
    dang_phat_trien(){
        alert('Đang phát triển');
    },
    process_product_status(status){
        var str = ''
        if(status == 0){
            str = 'Chờ thực hiện'
        }else if(status == 1){
            str = 'Đã thực hiện'
        }else if(status == 2){
            str = 'KH từ chối'
        }else if(status == 3){
            str = 'Không thực hiện'
        }else if(status == 4){
            str = 'Đề nghị hủy SP'
        }else if(status == 5){
            str = 'Gửi yêu cầu'
        }else if(status == 6){
            str = 'Đồng ý tiếp nhận'
        }else if(status == 7){
            str = 'Từ chối tiếp nhận'
        }else if(status == 8){
            str = 'Đã hỗ trợ xong'
        }
        return str;
    },
    process_status(status){
        var str = ''
        if(status == 0){
            str = 'Gửi yêu cầu'
        }else if(status == 1){
            str = 'Chờ tiếp nhận'
        }else if(status == 2){
            str = 'Chờ thực hiện'
        }else if(status == 3){
            str = 'Chờ giao trả'
        }else if(status == 4){
            str = 'Hoàn thành'
        }
        return str;
    },
    check_result(status){
        var str = ''
        if(status == 0){
            str = 'Thực hiện dịch vụ'
        }else if(status == 1){
            str = 'Không thực hiện và gửi trả khách hàng'
        }else if(status == 2){
            str = 'Hỏi ý kiến khách hàng'
        }else if(status == 3){
            str = '.Không sửa chữa và đề nghị hủy sản phẩm'
        }
        return str;
    },
    ReplacePhone(phone=''){
        phone = phone.toString();
        if (phone.length < 1){
            return phone;
        }
        //check ký tự đầu tiên có phải số 0 không
        if (phone.charAt(0) == '0'){
            return phone.replace('0','+84');
        }
        return  phone;
    },
    isValidHttpUrl(string) {
        let url;
        try {
            url = new URL(string);
        } catch (_) {
            return false;
        }
        return url.protocol === "http:" || url.protocol === "https:";
    }
}